import BaseStrategy from '../BaseStrategy.js'
import ReconcileForm from './ReconcileForm.js'
import EditForm from './EditForm.js'
import actions from '../../../../redux/actions/ui/dataImport/strategies/productTagStrategy.js'
import {getNounsFromValue} from '../../../../common/tokenizeOptions.js'

export default function ProductTagStrategy(props) {
  return (
    <BaseStrategy
      {...props}
      actions={actions}
      EditForm={EditForm}
      ReconcileForm={ReconcileForm}
    />
  )
}

ProductTagStrategy.title = actions.title
const option = {
  value: 'product_tag',
  display: 'Manage Product Tags',
  category: 'products',
  Component: ProductTagStrategy,
}
option.nouns = getNounsFromValue(
  `${option.value} ${option.display} ${option.category}`,
)
ProductTagStrategy.option = option
